
export const ACTION_GET_LIST_AND_COLUMNS = 'get-list-and-columns'
export const ACTION_GET_COLUMN_SET = 'get-column-set'
export const ACTION_UPSERT_COLUMN_SET = 'upsert-column-set'
export const ACTION_GET_FIELD_SCHEMA = 'get-field-schema'
export const ACTION_UPSERT_FIELD_SCHEMA = 'upsert-field-schema'
export const ACTION_GET_LIST = 'get-list'
export const ACTION_UPSERT_LIST = 'upsert-list'
export const ACTION_GET_ITEM = 'get-item'
export const ACTION_UPSERT_ITEM = 'upsert-item'